import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import FileProgress from './file-progress.jsx';
import { bytesToHumanSize } from '../lib/strformat.js';
import { isUrlRelative, sanitizeUrl } from '../lib/utils.js';
import Helpers from '../lib/helpers.js';
import { IconDownload2, IconFile, IconFileTxt, IconFileWord, IconFileExcel, IconFilePdf, IconFileZip, IconFileRar, IconFileMusic, IconFileXml, IconFileVideo, IconFileDefault  } from '../icons/svg/index.js';

class Attachment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      downloader: null,
      progress: 0
    };

    this.downloadFile = this.downloadFile.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  downloadFile(relativeUrl, filename, mimetype) {
    const url = Helpers.getDownloadURL(relativeUrl)
    if (!url) {
      this.props.onError("Invalid download URL '" + url + "'");
      return;
    }

    const downloader = this.props.tinode.getLargeFileHelper();
    this.setState({ downloader: downloader });
    downloader.download(url, filename, mimetype,
      loaded => this.setState({ progress: loaded / this.props.size }),
      err => this.props.onError(err, 'err')
    )
      .then(_ => this.setState({ downloader: null, progress: 0 },
        () => {
          const {formatMessage} = this.props.intl;
          Helpers.showSuccessToasts(formatMessage({
            id: 'toast_download_success',
            defaultMessage: 'Downloaded successfully',
          }));
        }))
      .catch(err => {
        if (err) {
          this.props.onError("Error downloading file: " + err.message, 'err');
        }
        this.setState({ downloader: null, progress: 0 });
      });
  }

  handleCancel() {
    if (this.props.uploading) {
      this.props.onCancelUpload();
    } else if (this.state.downloader) {
      this.state.downloader.cancel();
    }
  }

  // Hàm trả ảnh extension ứng với các loại file
  getIconFile = (filename) => {
    const extension = Helpers.getFileExtension(filename);
    switch (extension) {
      case 'txt':
        return <IconFileTxt></IconFileTxt>
      case 'doc':
      case 'docx':
        return <IconFileWord></IconFileWord>
      case 'xls':
      case 'xlsx':
        return <IconFileExcel></IconFileExcel>
      case 'pdf':
        return <IconFilePdf></IconFilePdf>
      case 'zip':
        return <IconFileZip></IconFileZip>
      case 'rar':
        return <IconFileRar></IconFileRar>
      case 'mov':
      case 'wav':
      case 'flac':
      case 'aac':
      case 'm4a':
      case 'mp3':
        return <IconFileMusic></IconFileMusic>
      case 'xml':
        return <IconFileXml></IconFileXml>
      case 'mp4':
      case 'avi':
      case 'flv':
      case 'wmv':
      case 'mkv':
      case 'webm':
      case 'ogg':
      case 'mpeg':
      case '3gp':
        return <IconFileVideo></IconFileVideo>
      case 'ppt':
      case 'pptx':
      case 'psd':
      default:
        return <IconFileDefault></IconFileDefault>
    }
  }

  render() {
    let filename = this.props.filename || 'file_attachment';
    if (filename.length > 36) {
      filename = filename.substr(0, 16) + '...' + filename.substr(-16);
    }
    let size = this.props.size > 0 ?
      <span className="small gray">{bytesToHumanSize(this.props.size)}</span> :
      null;

    // Detect if the download URL is relative or absolute.
    // If the URL is relative use LargeFileHelper to attach authentication
    // credentials to the request.
    let url, helperFunc;
    if (!this.props.uploading && !this.state.downloader && isUrlRelative(this.props.downloadUrl)) {
      // Relative URL. Use download helper.
      url = '#';
      helperFunc = (e) => {
        e.preventDefault();
        this.downloadFile(this.props.downloadUrl, this.props.filename, this.props.mimetype);
      };
    } else {
      url = sanitizeUrl(this.props.downloadUrl);
      helperFunc = null;
    }
    return (
      <div className="attachment">
        <div className='icon-attachment'>{this.getIconFile(filename)}</div>
        <div className="flex-column">
          <div className='file-name'>{filename}</div>
          <div className='file-size'>
            {size}
            {(this.props.uploading || this.state.downloader)
              &&
              <FileProgress progress={this.props.uploading ? this.props.progress : this.state.progress}
                onCancel={this.handleCancel} />
            }
          </div>
        </div>
        <div>
          {!(this.props.uploading || this.state.downloader) &&
            <div>{url ?
              <a href={url} download={this.props.filename} onClick={helperFunc}>
                <IconDownload2 />
              </a>
              :
              <IconDownload2 />
            }</div>
          }
        </div>
      </div>
    );
  }
};

export default injectIntl(Attachment);